import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BaseUrl } from "../../../Helper/BaseUrl";
import { toastErrorr, toastSuccesss } from "../../../Helper/ToastMessage";


// Get Table Data
export const STPMachineryOperationTableDataAPI = createAsyncThunk("STPMachineryOperationTableData", async ({ data }) => {
    const {
        ReadingDate,
        M_STP_UnitTypeID,
        M_STP_EquipmentTypeID,
        M_WardID,
        M_UserID,
        Flag,
        token,
        From,
        To,
        handleGetExport
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/APKDashboard/Get_WEB_STP_T_STP_MachineryOperation_Select?ReadingDate=${ReadingDate}&M_WardID=${M_WardID ? M_WardID : '0'}&M_STP_UnitTypeID=${M_STP_UnitTypeID ? M_STP_UnitTypeID : '0'}&M_STP_EquipmentTypeID=${M_STP_EquipmentTypeID ? M_STP_EquipmentTypeID : '0'}&M_UserID=${M_UserID}&From=${From}&To=${To}&Flag=${Flag}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            // console.log(result.data1, result.data) 
            if (result.code >= 200 && result.code <= 300 && result.data) {
                handleGetExport && handleGetExport()
                return result.data

            } else {
                return result
            }
        })
})

const STPMachineryOperationTableDataSlice = createSlice({
    name: "STPMachineryOperationTableData",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(STPMachineryOperationTableDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(STPMachineryOperationTableDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(STPMachineryOperationTableDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const STPMachineryOperationTableDataReducer = STPMachineryOperationTableDataSlice.reducer

export const STPMachineryOperationTableExportDataAPI = createAsyncThunk("STPMachineryOperationTableExportData", async ({ data }) => {
    const {
        ReadingDate,
        M_STP_UnitTypeID,
        M_STP_EquipmentTypeID,
        M_WardID,
        M_UserID,
        Flag,
        token,
        From,
        To,
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/APKDashboard/Get_WEB_STP_T_STP_MachineryOperation_Select?ReadingDate=${ReadingDate}&M_WardID=${M_WardID ? M_WardID : '0'}&M_STP_UnitTypeID=${M_STP_UnitTypeID ? M_STP_UnitTypeID : '0'}&M_STP_EquipmentTypeID=${M_STP_EquipmentTypeID ? M_STP_EquipmentTypeID : '0'}&M_UserID=${M_UserID}&From=${From}&To=${To}&Flag=${Flag}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            // console.log(result.data1, result.data) 
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data

            } else {
                return result
            }
        })
})

const STPMachineryOperationExportDataSlice = createSlice({
    name: "STPMachineryOperationExportData",
    initialState: {
        isExportLoading: false,
        ExportTableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(STPMachineryOperationTableExportDataAPI.pending, (state, action) => {
            state.isExportLoading = true;
        });
        builder.addCase(STPMachineryOperationTableExportDataAPI.fulfilled, (state, action) => {
            state.isExportLoading = false;
            state.ExportTableData = action.payload;
        });
        builder.addCase(STPMachineryOperationTableExportDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isExportLoading = false;
            state.isError = true;
            state.ExportTableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const STPMachineryOperationTableExportDataReducer = STPMachineryOperationExportDataSlice.reducer


export const STPMachineryOperationPostDataAPI = createAsyncThunk("STPMachineryOperationPostData", async ({ data }) => {
    const {
        T_STP_MachineryOperationID,
        OperationHours,
        CurrentAmp,
        M_UserID,
        token,
        Flag,
        handleIsPost,
        handleClearField,
        handleOnCloseClick,
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var formdata = new FormData();
    formdata.append("T_STP_MachineryOperationID", T_STP_MachineryOperationID);
    formdata.append("OperationHours", OperationHours);
    formdata.append("CurrentAmp", CurrentAmp);
    formdata.append("M_UserID", M_UserID);

    var requestOptions = {
        method: 'PATCH',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
    };

    fetch(`${BaseUrl}/APKDashboard/Post_WEB_STP_T_STP_MachineryOperation_Update`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                handleIsPost()
                // handleClearField()
                handleOnCloseClick()
                toastSuccesss(result.message)
                return result.data
            } else {
                toastErrorr(result.message)
            }
            return result
        })
})

const STPMachineryOperationPostDataSlice = createSlice({
    name: "STPMachineryOperationPostData",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(STPMachineryOperationPostDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(STPMachineryOperationPostDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(STPMachineryOperationPostDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            // toastErrorr('Something went wrong')
        });
    },
})

export const STPMachineryOperationPostDataReducer = STPMachineryOperationPostDataSlice.reducer

// -----------------Delete API ---------------

export const STPMachineryOperationDeleteAPI = createAsyncThunk("STPMachineryOperationDelete", async ({ data }) => {
    const {
        T_STP_MachineryOperationID,
        M_UserID,
        token,
        handleIsPost
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);


    var formdata = new FormData();
    formdata.append("T_STP_MachineryOperationID", T_STP_MachineryOperationID);
    formdata.append("M_UserID", M_UserID);

    var requestOptions = {
        method: 'DELETE',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
    };

    fetch(`${BaseUrl}/APKDashboard/WEB_STP_T_STP_MachineryOperation_Delete`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.status) {
                handleIsPost()
                toastSuccesss(result.message)
            } else {
                toastErrorr(result.message)

            }
            return result

        })
})

const STPMachineryOperationDeleteSlice = createSlice({
    name: "STPMachineryOperationDelete",
    initialState: {
        isDeleteLoading: false,
        SectorData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(STPMachineryOperationDeleteAPI.pending, (state, action) => {
            state.isDeleteLoading = true;
        });
        builder.addCase(STPMachineryOperationDeleteAPI.fulfilled, (state, action) => {
            state.isDeleteLoading = false;
            state.SectorData = action.payload;

        });
        builder.addCase(STPMachineryOperationDeleteAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isDeleteLoading = false;
            state.isError = true;
            state.SectorData = null;
            // toastErrorr('Something went wrong')
        });
    },
})

export const STPMachineryOperationDeleteReducer = STPMachineryOperationDeleteSlice.reducer